import React from "react";
import DOMPurify from "dompurify";

// Custom tooltip for react-joyride v3.
// Receives TooltipRenderProps (index, size, isLastStep, step, backProps, skipProps,
// primaryProps, tooltipProps) plus `isMobileView` and `translation` injected by SiteTourManager.
// All presentation lives in Style/Components/_siteTour.scss — colours come from Theme Master via
// CSS custom properties there, so nothing here needs to know about theming.
const SiteTourTooltip = ({
  index,
  size,
  isLastStep,
  step,
  backProps,
  skipProps,
  primaryProps,
  tooltipProps,
  isMobileView,
  translation,
}) => {
  // Tour content is admin-authored HTML (Jodit editor) — sanitize before rendering.
  const safeContent = step?.content ? DOMPurify.sanitize(step.content) : "";

  return (
    <div
      {...tooltipProps}
      // Keyed on the step so React remounts rather than reuses this node between steps —
      // otherwise the fade-in animation only ever plays once, on the first step.
      key={index}
      className={`site-tour-tooltip${isMobileView ? " is-mobile" : ""}`}
    >
      {safeContent ? (
        <div
          className="site-tour-tooltip-content"
          dangerouslySetInnerHTML={{ __html: safeContent }}
        />
      ) : null}

      <div className="site-tour-actions">
        {/* Nothing left to skip on the last step — the primary button ends the tour. This also
            covers a single-step tour, which shows only the primary action. */}
        {!isLastStep && (
          <button type="button" {...skipProps} className="site-tour-skip">
            <div className="site-tour-skip-label">
              {translation?.skipTour}
            </div>
          </button>
        )}
        <div className="site-tour-nav">
          {index > 0 && (
            <button type="button" {...backProps} className="site-tour-prev">
              {translation?.previous}
            </button>
          )}
          <button type="button" {...primaryProps} className="site-tour-next">
            {isLastStep ? translation?.getStarted : translation?.next}
          </button>
        </div>
      </div>

      {(
        <div className="site-tour-step">
          {`${translation?.step || "Step"} ${index + 1} ${translation?.of || "of"} ${size}`}
        </div>
      )}
    </div>
  );
};

export default SiteTourTooltip;
